import styled from "styled-components";
import { grayColors } from '../../../../../../../themes/architecture/gray-colors';

export const ClientSettingsDropdownListItemDefaultBox = styled.div<{ isSelected: boolean }>`
    display: flex;
    align-items: center;
    gap: 13px;

    position: relative;
    
    cursor: pointer;
    color: ${({ isSelected, theme }) => isSelected ? theme.colors.brandPrimary : grayColors.gray203};
    font-weight: ${({ isSelected }) => isSelected ? 600 : 500};
    font-size: 12px;
    transition: color 0.4s;

    &:hover {
        color: ${({ isSelected, theme }) => isSelected ? theme.colors.brandPrimary : grayColors.gray233};
    }

    &:not(:last-of-type)::after {
        display: block;
        content: "";
        position: absolute;
        bottom: -6px;
        left: 0;

        box-sizing: content-box;
        background: ${({ theme }) => theme.colors.backgroundDark};
        box-shadow: 0px 0.35px 0px 0px ${({ theme }) => theme.colors.boxBorderContrast};
        width: 100%;
        height: 1px;
    }
`